import { api } from './api';
import type { AuthenticateSignerRequestDto } from '../types/signatureSigner';

export interface SignerStepUpResult {
  confirmationNonce: string;
  signerId: string;
  sessionExpiresAtUtc?: string;
  documentId?: string;
  documentTitle?: string | null;
}

export async function stepUpSignerIdentity(
  documentId: string,
  body: AuthenticateSignerRequestDto
): Promise<SignerStepUpResult> {
  const { data } = await api.post<SignerStepUpResult>(
    `/signatures/signer/documents/${documentId}/step-up`,
    body
  );
  return data;
}

export async function establishWorkflowSignerSigningSession(
  documentId: string,
  signerId: string
): Promise<SignerStepUpResult> {
  const { data } = await api.post<SignerStepUpResult>(
    `/signatures/signer/documents/${documentId}/workflow-signing-session`,
    { signerId }
  );
  return data;
}

export async function confirmElectronicSignature(
  documentId: string,
  body: { inviteToken?: string | null; signerId?: string | null; confirmationNonce: string; acknowledgedTerms: boolean }
): Promise<unknown> {
  const { data } = await api.post(
    `/signatures/signer/documents/${documentId}/confirm-electronic`,
    body
  );
  return data;
}

export async function rejectSignature(
  documentId: string,
  body: { inviteToken?: string | null; signerId?: string | null; reason: string }
): Promise<void> {
  await api.post(`/signatures/signer/documents/${documentId}/reject`, body);
}

export async function submitHandwrittenSignature(
  documentId: string,
  body: {
    inviteToken?: string | null;
    signerId?: string | null;
    confirmationNonce: string;
    imageBase64: string;
    contentType?: string;
  }
): Promise<unknown> {
  const { data } = await api.post(
    `/signatures/signer/documents/${documentId}/handwritten`,
    body
  );
  return data;
}

export async function submitCertificateSignature(
  documentId: string,
  params: {
    certificateFile: File;
    password: string;
    confirmationNonce: string;
    inviteToken?: string | null;
    signerId?: string | null;
  }
): Promise<unknown> {
  const fd = new FormData();
  fd.append('certificateFile', params.certificateFile);
  fd.append('password', params.password);
  fd.append('confirmationNonce', params.confirmationNonce);
  if (params.inviteToken) {
    fd.append('inviteToken', params.inviteToken);
  }
  if (params.signerId) {
    fd.append('signerId', params.signerId);
  }
  const { data } = await api.post(
    `/signatures/signer/documents/${documentId}/certificate`,
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}
